import EthereumService from '@/services/ethereum'
import cookie from '@/utils/cookie'

export default class Service extends EthereumService {
  constructor (options) {
    super()
    this.store = options.store
    this.kulapApi = options.kulapApi
  }

  async confirmEmail (confirmationCode, email, recaptchaToken) {
    let data = {
      confirmationCode,
      email,
      recaptchaToken
    }
    let referralCode = cookie.get('ref')
    if (referralCode) data.referralCode = referralCode
    const { data: result } = await this.kulapApi.confirmEmail(data)
    return result
  }

  async sendConfirmationEmail (code) {
    const { data } = await this.kulapApi.sendConfirmationEmail(code)
    return data
  }

  logout () {
    this.kulapApi.postLogout()
    cookie.remove('accessToken')
    cookie.remove('user')
    this.updateUserData()
  }

  async updateUserData () {
    if (cookie.get('accessToken') && cookie.get('user')) {
      const { data } = await this.kulapApi.getUserProfile()
      this.store.dispatch('setUser', data)
    } else {
      this.store.dispatch('setUser', {})
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/ConfirmEmail/service.js